// UnderDevelopment.js
import React from 'react';
import './Terms&Conditions.css';

const UnderDevelopment = () => {
    return (
        <div className="under-development">
            <div className="message-box">
                <h1>🚧 Page Under Development</h1>
                <p>We’re working hard to bring this page to life.</p>
                <p>Please check back soon!</p>
            </div>
        </div>
    );
};

export default UnderDevelopment;
